// src/hooks/useSupabase.ts
import { useState, useEffect, useCallback } from "react";
import { supabase } from "../lib/supabase/client";
import { authService } from "../services/authService";

/**
 * Hook global para gerenciamento de estado do Supabase
 */
export const useSupabase = () => {
  const [user, setUser] = useState(authService.getCurrentUser());
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  /**
   * Efeito para verificar autenticação inicial
   */
  useEffect(() => {
    const checkAuth = () => {
      const currentUser = authService.getCurrentUser();
      setUser(currentUser);
    };

    checkAuth();
  }, []);

  /**
   * Login wrapper com tratamento de estado
   */
  const login = useCallback(async (email: string, password: string) => {
    setLoading(true);
    setError(null);

    const result = await authService.login(email, password);

    if (result.success) {
      setUser(result.user);
    } else {
      setError(result.error || "Erro no login");
    }

    setLoading(false);
    return result;
  }, []);

  /**
   * Logout wrapper
   */
  const logout = useCallback(async () => {
    setLoading(true);

    const result = await authService.logout();

    if (result.success) {
      setUser(null);
    } else {
      setError(result.error || "Erro no logout");
    }

    setLoading(false);
    return result;
  }, []);

  /**
   * Registro wrapper
   */
  const register = useCallback(
    async (email: string, password: string, userData: any) => {
      setLoading(true);
      setError(null);

      const result = await authService.register(email, password, userData);

      if (!result.success) {
        setError(result.error || "Erro no registro");
      }

      setLoading(false);
      return result;
    },
    []
  );

  /**
   * Limpar erro
   */
  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return {
    // Estado
    user,
    loading,
    error,

    // Ações
    login,
    logout,
    register,
    clearError,

    // Utilitários
    isAuthenticated: authService.isAuthenticated(),

    // Cliente direto (uso avançado)
    client: supabase,
  };
};
